import getCookie from "components/LanguageProvider/utils/cookies";
import safely from "utils/safeCookie";
// Shared by hooks/useCookieConsent (typed React state) and hasAnalyticsConsent below
// (plain function for call sites outside a component tree, e.g. utils/UTM.ts) so the
// cookieyes-consent cookie format is only parsed in one place.
export const parseConsentCookie = (cookieStr) => {
    const entries = cookieStr.split(",").map((pair) => pair.split(":"));
    const result = {};
    entries.forEach(([key, value]) => {
        if (key && value) {
            result[key.trim()] = value.trim();
        }
    });
    return result;
};
// Standalone (non-hook) analytics consent check for call sites outside a component tree
// (e.g. utils/UTM.ts), mirroring the default-deny-for-UK/EU logic in hooks/useCookieConsent.
// Fails safe: only a confirmed "false" (visitor is known not to be in the UK/EU) grants
// analytics by default. A missing region cookie is treated the same as "true" (deny) rather
// than assuming it's safe to track - this can happen on a cold cache hit before the region
// cookie has had a chance to be set (see SetRegionRestrictionCookieMiddleware). This is a plain,
// synchronous read with no fetch-and-retry of its own (unlike useCookieConsent): by the time a
// donor submits a form, useCookieConsent has had the whole page visit to resolve the cookie via
// utils/regionConsent's uncached round trip, so it should already be set here.
export const hasAnalyticsConsent = () => {
    const cookie = safely(() => getCookie("cookieyes-consent"), null);
    if (!cookie) {
        return safely(() => getCookie("cookie_consent_region_restriction"), null) === "false";
    }
    return parseConsentCookie(cookie).analytics === "yes";
};
